export default {
  OVERALL_GOALS_STATUS_REPOSITORY: Symbol.for('OVERALL_GOALS_STATUS_REPOSITORY'),
  GET_OVERALL_GOALS_STATUS_QUERY: Symbol.for('GET_OVERALL_GOALS_STATUS_QUERY'),
  OVERALL_GOALS_STATUS_STATE_MANAGER: Symbol.for('OVERALL_GOALS_STATUS_STATE_MANAGER'),
};
